import parser from 'ua-parser-js'
import { includes } from 'lodash-es'

import VenderContent from 'components/pages/Vender/VenderContent'
import MetaTags from 'components/pages/Vender/VenderContent/MetaTags'
import NoindexRemoval from 'components/common/NoindexRemoval'
import withLivingSinyi from 'utils/withLivingSinyi'
import {
  getVenderByUrlId,
  getVenderById,
  getAlbumCount,
  getArticleCount,
} from 'utils/api'

const VenderContentPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        vender={props.fallbackData?.vender}
        albumCount={props.fallbackData?.albumCount}
        articleCount={props.fallbackData?.articleCount}
      />
      <VenderContent {...props} />
    </>
  )
}

export const getServerSideProps = async (context) => {
  const ua = parser(context.req.headers['user-agent'])
  const isMobile = includes(['mobile', 'tablet'], ua.device.type)
  const venderUrlId = context.params.venderUrlId

  // getVenderByUrlId & getVenderById 的錯誤回傳值從 null 改為正常錯誤訊息，相對應的邏輯有進行調整
  const [venderByUrlId, errorByUrlId] = await getVenderByUrlId(venderUrlId)

  // 檢查是否為 otherUrlIds，若是則重新導向到主要的 urlId（保留查詢參數）
  if (venderByUrlId?.otherUrlIds?.includes(venderUrlId)) {
    const { venderUrlId: _urlId, ...restQuery } = context.query
    const queryStr = new URLSearchParams(restQuery).toString()
    const destination = queryStr
      ? `/vender/${venderByUrlId.urlId}?${queryStr}`
      : `/vender/${venderByUrlId.urlId}`
    return {
      redirect: {
        destination,
        permanent: true,
      },
    }
  }

  if (venderByUrlId && !venderByUrlId?.introductionInfo?.isVisible) {
    const { res } = context
    res.append('Cache-Control', 'max-age=300') // 建議轉址邏輯都穩定後，移除快取設定
    res.writeHead(301, { location: '/vender?page=1' })
    res.end()
    return { props: {} }
  }

  // 若無法從venderUrlId取得文章，則該欄位可能為_id
  if (!venderByUrlId) {
    const id = venderUrlId
    const [venderById, errorById] = await getVenderById(id)
    if ((venderById && !venderById?.introductionInfo?.isVisible) || errorById) {
      const { res } = context
      res.append('Cache-Control', 'max-age=300') // 建議轉址邏輯都穩定後，移除快取設定
      res.writeHead(301, { location: '/vender?page=1' })
      res.end()
      return { props: {} }
    }
    if (venderById) {
      return {
        redirect: {
          destination: `/vender/${venderById?.urlId}`,
          permanent: false,
        },
      }
    }
  }

  const [albumCountResult, articleCountResult] = await Promise.all(
    !errorByUrlId
      ? [
          getAlbumCount({ venderId: venderByUrlId?._id }),
          getArticleCount({ venderId: venderByUrlId?._id }),
        ]
      : [[0], [0]]
  )
  const [albumCount, albumCountError] = albumCountResult
  const [articleCount, articleCountError] = articleCountResult

  return {
    props: {
      fallbackData: {
        venderUrlId: venderUrlId || '',
        vender: venderByUrlId,
        albumCount,
        articleCount,
      },
      isMobile,
      resolvedUrl: context.resolvedUrl,
    },
  }
}

export default withLivingSinyi(VenderContentPage)
